const mockData = [
  {
    url: 'remoteComponents/rTooltipExample.js',
    type: 'home',
    title: 'Home Pgae',
  },
  {
    url: 'remoteComponents/rPopoverExample.js',
    type: 'info-circle',
    usePopover: true,
  },
  {
    url: 'remoteComponents/rModalExample.js',
    type: 'select',
    title: 'Open Modal',
  },
];

export async function queryRemotePlugin() {
  return Promise.resolve(mockData);
}
